// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"1aba15c0","554":"3c6fda01","589":"c162d82f"}[chunkId] + ".chunk.css";
};